import { navigate } from "gatsby";
import React from "react";
import { Provider } from "react-redux";
import { AdminLayout } from "./src/components/index";
import Layout from "./src/components/Web/Layout";
import { AuthProvider } from "./src/context/AuthContext";
import store from "./src/redux";

declare global {
  interface Window {
	___navigate?: (path: string, options?: { replace?: boolean }) => void
  }
}

export const wrapRootElement = ({ element }) => {
  	return <Provider store={store}>{element}</Provider>
}

// Wrap Page Element for Layout
export const wrapPageElement = ({ element, props}) => {
	const path = props.location.pathname
	if (path.startsWith('/admin')) {
        return( <AuthProvider><AdminLayout>{element}</AdminLayout></AuthProvider>)
    }else{
		return(<AuthProvider><Layout {...props}>{element}</Layout></AuthProvider>)
	}
}
			// {/* <Layout {...props} language={language}>{element}</Layout> */}

export const onClientEntry = () => {
	if (typeof window !== 'undefined') {
		const savedLanguage = localStorage.getItem('preferredLanguage') || 'en'
		if (window.location.pathname === '/') {
			if(savedLanguage !== 'en') {
				const targetPath = `/${savedLanguage}/`
				if (window.location.pathname !== targetPath){
					setTimeout(() => {
						if (typeof window.___navigate === "function") {
							(navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(`/${savedLanguage}/`)
						} else {
							console.warn("Gatsby navigation is not yet initialized.")
						}
					}, 0)
				}
			}
		}
	}
}
export const onRouteUpdate = ({ location }) => {
	const path = location.pathname
	if (path.startsWith("/en")) {
		let newPath = path.replace(/^\/en/, "/");
		newPath = newPath.replace('//', '/')
		if (newPath !== path) {
			(navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(newPath, { replace: true });
		}
	}
};